module.exports = "<a installer-root-link href class=logo__link>\n  <img class=logo__icon ng-src={{getServiceLogo(productName)}} />\n</a>\n";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/logo/logo.html
// module id = 846
// module chunks = 0